var $9dcb7a1fe67a3799$exports = {};
$9dcb7a1fe67a3799$exports = {
    "colorFormat": `\u{5E4}\u{5D5}\u{5E8}\u{5DE}\u{5D8} \u{5E6}\u{5D1}\u{5E2}`,
    "hex": `\u{5DE}\u{5E9}\u{5D5}\u{5E9}\u{5D4}`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$9dcb7a1fe67a3799$exports as default};
//# sourceMappingURL=he-IL.mjs.map
